import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCircleCheck, faClipboardCheck, faFlask, faHandDots } from '@fortawesome/free-solid-svg-icons'

export function MedicalSelectionGuide() {
  return (
    <section id="panduan-memilih" className="scroll-mt-6 bg-white py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 text-xs font-black uppercase tracking-[0.2em] text-sky-800">
            <FontAwesomeIcon icon={faFlask} className="h-4 w-4" />
            Panduan memilih sarung tangan
          </p>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-slate-950 md:text-4xl">Mulai dari bahannya: latex atau nitrile</h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600">
            Bahan menentukan siapa yang boleh memakai dan pilihan apa saja yang tersedia. Sebutkan bahan yang dipilih saat meminta quotation, lalu lengkapi dengan ukuran dan jumlah per ukuran.
          </p>
        </div>

        <div className="mt-9 grid gap-5 lg:grid-cols-2">
          <article className="rounded-3xl border border-slate-200 bg-slate-50 p-6 md:p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-slate-950 text-sky-300">
              <FontAwesomeIcon icon={faHandDots} className="h-5 w-5" />
            </div>
            <p className="mt-6 text-xs font-black uppercase tracking-[0.18em] text-slate-500">Latex</p>
            <h3 className="mt-2 text-2xl font-black tracking-tight text-slate-950">Delapan dari sebelas produk berbahan latex</h3>
            <ul className="mt-5 space-y-3 text-sm leading-relaxed text-slate-600">
              {[
                'Tersedia dari Shamrock, NAYA, Otoro, dan lini Disposable.',
                'Ada pilihan powder free dan berbedak, termasuk warna hitam dan pink pada pilihan tertentu.',
                'Periksa riwayat sensitivitas latex pengguna dan SOP fasilitas sebelum menentukan.',
              ].map((item) => (
                <li key={item} className="flex gap-3"><FontAwesomeIcon icon={faCheck} className="mt-1 h-3.5 w-3.5 flex-shrink-0 text-sky-700" />{item}</li>
              ))}
            </ul>
          </article>
          <article className="rounded-3xl bg-[#102d3d] p-6 text-white md:p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-sky-300 text-[#102d3d]">
              <FontAwesomeIcon icon={faFlask} className="h-5 w-5" />
            </div>
            <p className="mt-6 text-xs font-black uppercase tracking-[0.18em] text-sky-300">Nitrile</p>
            <h3 className="mt-2 text-2xl font-black tracking-tight">Dibuat tanpa bahan latex alami</h3>
            <ul className="mt-5 space-y-3 text-sm leading-relaxed text-slate-300">
              {[
                'Tiga produk nitrile: Shamrock Nitrile Powder Free serta Disposable Nitrile biru dan hitam.',
                'Seluruhnya tanpa bedak dengan isi 100 pcs per box.',
                'Relevan ketika fasilitas membatasi penggunaan bahan latex alami.',
              ].map((item) => (
                <li key={item} className="flex gap-3"><FontAwesomeIcon icon={faCheck} className="mt-1 h-3.5 w-3.5 flex-shrink-0 text-sky-300" />{item}</li>
              ))}
            </ul>
          </article>
        </div>
      </div>
    </section>
  )
}

export function MedicalOrderChecklist() {
  const items = ['Nama produk atau bahan', 'Ukuran atau warna per produk', 'Jumlah box', 'Kota tujuan', 'Target penerimaan', 'Dokumen wajib untuk PO']
  return (
    <div className="rounded-3xl border border-sky-200 bg-sky-50 p-6 md:p-8">
      <p className="inline-flex items-center gap-2 text-xs font-black uppercase tracking-[0.2em] text-sky-900">
        <FontAwesomeIcon icon={faClipboardCheck} className="h-4 w-4" />
        Data untuk admin
      </p>
      <ul className="mt-5 grid gap-3 sm:grid-cols-2">
        {items.map((item) => (
          <li key={item} className="flex items-center gap-3 rounded-xl bg-white px-4 py-3 text-sm font-bold text-slate-800 shadow-sm">
            <FontAwesomeIcon icon={faCircleCheck} className="h-4 w-4 flex-shrink-0 text-emerald-700" />
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}
